import { render, staticRenderFns } from "./PsychoReport.vue?vue&type=template&id=7ed35c7a"
import script from "./PsychoReport.vue?vue&type=script&lang=js"
export * from "./PsychoReport.vue?vue&type=script&lang=js"
import style0 from "./PsychoReport.vue?vue&type=style&index=0&id=7ed35c7a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VExpandTransition,VIcon})
